import { Factory, association } from 'miragejs'
import { faker } from '@faker-js/faker'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

export default Factory.extend({
  subscriptionType() {
    return faker.helpers.arrayElement([SubscriptionType.Reading, SubscriptionType.Maths, SubscriptionType.Writing])
  },

  school: association(),

  partner: association(),
})
